<template>
  <FloatingLabelTextInput
    label="Phone number  (WhatsApp preferred)"
    type="tel"
    :aria-label="contactFields.phoneNumber.ariaLabel"
    :autocomplete="contactFields.phoneNumber.autocomplete"
    :error="contactFields.phoneNumber.error"
    :model-value="contactFields.phoneNumber.value"
    :on-update-model-value="contactFields.phoneNumber.update"
  />
  <FloatingLabelComboBox
    label="Nationality"
    :aria-label="contactFields.nationality.ariaLabel"
    :error="contactFields.nationality.error"
    :model-value="contactFields.nationality.value"
    :on-update-model-value="contactFields.nationality.update"
    :options="options"
  />
</template>

<script setup lang="ts">
import { useCountry } from '@/composables/utils/useCountry';
import type { Option } from '@/models/option';
import FloatingLabelComboBox from '@/wabunka-src/common/components/stateful/FloatingLabelComboBox/FloatingLabelComboBox.vue';
import FloatingLabelTextInput from '@/wabunka-src/common/components/stateful/FloatingLabelTextInput/FloatingLabelTextInput.vue';
import { useGlobalWabunkaReservationForm } from '@/wabunka-src/common/features/Reservation/composables/forms/useGlobalWabunkaReservationForm';

interface Props {
  getErrorMessage: (s: string) => string;
}

const props = defineProps<Props>();

const { form } = useGlobalWabunkaReservationForm();

// 代理予約では参加者の連絡先を聞く。aria-label は送信前の形式エラーを欄ごとに出すときの鍵にもなる
const contactFields = computed(() => {
  const step2 = form.value.step2;
  if (step2.shouldShowSomeoneElseForm) {
    return {
      phoneNumber: {
        ariaLabel: 'forSomeoneElsePhoneNumber',
        autocomplete: 'section-participant tel',
        error: props.getErrorMessage('step2.forSomeoneElsePhoneNumber'),
        value: step2.forSomeoneElsePhoneNumber,
        update: (value: string) => (form.value.step2.forSomeoneElsePhoneNumber = value),
      },
      nationality: {
        ariaLabel: 'forSomeoneElseNationality',
        error: props.getErrorMessage('step2.forSomeoneElseNationality'),
        value: step2.forSomeoneElseNationality,
        update: (value: string | number) => (form.value.step2.forSomeoneElseNationality = String(value)),
      },
    };
  }
  return {
    phoneNumber: {
      ariaLabel: 'forMyselfPhoneNumber',
      autocomplete: 'tel',
      error: props.getErrorMessage('step2.forMyselfPhoneNumber'),
      value: step2.forMyselfPhoneNumber,
      update: (value: string) => (form.value.step2.forMyselfPhoneNumber = value),
    },
    nationality: {
      ariaLabel: 'forMyselfNationality',
      error: props.getErrorMessage('step2.forMyselfNationality'),
      value: step2.forMyselfNationality,
      update: (value: string | number) => (form.value.step2.forMyselfNationality = String(value)),
    },
  };
});

// 国名一覧は定数なので mount 後に入れる（SSR とクライアントで同じ値になり、初期描画を重くしない）
const options = ref<Option[]>([]);
onMounted(() => {
  options.value = useCountry();
});
</script>
